import { render, staticRenderFns } from "./omsetedisi_list.vue?vue&type=template&id=4d001e7f"
import script from "./omsetedisi_list.vue?vue&type=script&lang=js"
export * from "./omsetedisi_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports